import webRadios from './src/web-radio.vue'

webRadios.install = function (Vue){
    Vue.comment(webRadios,name,webRadios)
}

export default webRadios